module.exports = __webpack_public_path__ + "static/assets/1581e0fe45e8c63459bb11a9ebc306c7.svg";